import { AnimatedCircularProgressBar } from '@talentmesh/ui/components/animated-circular-progress-bar';
import { useSearchCriteria } from '../../../../api/useSearchCriteria';
import { useAiSearchProfilePopoutContext } from '../../AiSearchProfilePopoutContext';
import UIStrings from '@/Utils/UIStrings';

const ProfileScore = () => {
    const { selectedProfile } = useAiSearchProfilePopoutContext();
    const { data } = useSearchCriteria();

    return (
        <div className="flex flex-col gap-4">
            {selectedProfile?.searchCriteriaScores?.map(
                ({ justification, score, scoreLevel, searchCriteriaId }, index) => (
                    <div
                        key={searchCriteriaId}
                        className="flex flex-row items-start gap-4"
                        style={{ animationDelay: `${index * 45}ms` }}
                    >
                        <AnimatedCircularProgressBar
                            value={score ?? 0}
                            level={scoreLevel}
                            className="size-12 text-sm"
                        />
                        <div className="flex min-w-0 flex-1 flex-col gap-3">
                            <div className="text-foreground w-full">
                                <p className="text-sm font-medium">{UIStrings.Criteria(index + 1)}</p>
                                <p className="text-sm">
                                    {data?.criteria.find(({ id }) => id === searchCriteriaId)?.criterion}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-medium">{UIStrings.Justification}</p>
                                <p className="text-sm whitespace-pre-line">{justification}</p>
                            </div>
                        </div>
                    </div>
                ),
            )}
        </div>
    );
};

export default ProfileScore;
